<template>
  <div class="player-container">
    <div class="countdown" v-if="liveStatus == 0">
      距直播开始还有 <span>{{ countdown.days }}</span>天<span>{{ countdown.hours }}</span>时<span>{{ countdown.mins
        }}</span>分<span>{{ countdown.seconds }}</span>秒
    </div>
    <div class="liveEnd" v-if="liveStatus == 2">
      直播已结束<br>
      点击下方日程安排即可查看精彩回放

    </div>
    <div class="bg_cover" id="test" v-if="liveDetails != {} && liveDetails.banner_type == 2 && showPoster">
      <img :src="liveDetails.banner" alt="">
      <ul>
        <!-- <p :style="{ 'color': liveDetails.schedule_font_color_hex ? liveDetails.schedule_font_color_hex : '#fff' }">{{
          liveDetails.time }}{{ liveDetails.name }}{{ liveDetails.hall_name ? '(' + liveDetails.hall_name + ')' : '' }}
        </p> -->
        <li v-for="ct in recordedList"
          :style="{ 'color': liveDetails.schedule_font_color_hex ? liveDetails.schedule_font_color_hex : '#fff' }"
          :key="ct.id">
          <span
            :style="{ 'background-color': liveDetails.schedule_font_color_hex ? liveDetails.schedule_font_color_hex : '#fff' }"></span>
          {{ ct.name }}
        </li>
        <div class="player-icon" @click="getLiveInfo(liveDetails, 'play')">
          <van-icon name="play" />
        </div>

      </ul>
    </div>
    <video-player class="vjs-custom-skin" @canplay="onPlayerPlay" @ended="onPlayerEnd" :options="playerOptions"
      @play="onVideoPlay" ref="videoPlayer" :playsinline="playsinline"></video-player>
  </div>
</template>

<script>
//引入video样式
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
//引入hls.js
import 'videojs-contrib-hls.js/src/videojs.hlsjs'
import $ from 'jquery'
// import html2Canvas from 'html2canvas'
let codeTimer;   //定时器
import { Icon } from 'vant';
export default {
  components: {
    Icon
  },
  data() {
    return {
      liveStatus: 1,       //直播状态  0:未开始   1:进行中  2:已结束   3:播放录播默认进行中
      liveDetails: {},       //直播详情
      video_url: this.$store.state.videoUrl,
      playerOptions: {},   //直播视频配置
      liveStartTime: null,  //直播开始时间戳
      liveEndTime: null,    //直播结束时间戳
      currentTime: null,   //当前时间戳
      dValue: null,      //距直播开始时间
      // showCountFlag:false,   //展示倒计时
      newRecordedList: [],
      recordedList: [],
      countdown: {
        days: 0,
        hours: 0,
        mins: 0,
        seconds: 0
      },
      showPoster: false
    }
  },
  watch: {
    '$store.state.videoUrl'(newData, oldData) {
      if (newData) {
        this.playerOptions.sources[0].type = 'video/mp4';
        this.playerOptions.sources[0].src = newData;
        this.playerOptions.notSupportedMessage = '播放结束';
        this.liveStatus = 3;
      }

    },
    '$store.state.recording'(newData, oldData) {
      this.handleSchedule();
    }
  },
  mounted() {

  },
  destroyed() {
    this.clearCodeTimer();
  },
  methods: {

    // coverToImg() {
    //   var that=this
    //     var fileName = document.title + ".png";
    //     var domElement = document.querySelector("#test");
    //     html2Canvas(domElement, {
    //       allowTaint: true,
    //       useCORS: true,
    //       scrollY: 0
    //     }).then(function(canvas) {
    //       if (!!window.ActiveXObject || "ActiveXObject" in window) {
    //         //判断IE下保存方法
    //         var blob = canvas.msToBlob();
    //         window.navigator.msSaveBlob(blob, fileName);
    //       } else {
    //         var imgUri = canvas.toDataURL("image/png"); // 获取生成的图片的url
    //         // 创建一个 img 标签，把图片插入到 DOM 中
    //         // 这里使用 img 是因为在客户端中，不能直接下载，要调用原生的方法
    //         const createImg = document.querySelector("#taskImage");
    //         createImg.setAttribute("src", imgUri);
    //         createImg.setAttribute("width", "100%");
    //         console.log("coverimg", imgUri);
    //         that.$emit('canvasToShareImg', imgUri);
    //       }
    //     });
    //   },
    //直播信息
    getLiveInfo(data, name = null) {
      console.log(data.play_url_m3u8)
      this.liveDetails = data;
      if (this.liveDetails.banner_type == 2) {
        this.showPoster = true;
      }

      this.playerOptions = {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: true, //如果true,浏览器准备好时开始回放。
        controls: true, //控制条
        preload: 'auto', //视频预加载
        muted: false, //默认情况下将会消除任何音频。
        loop: false, //视频一结束就重新开始。
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: 'application/x-mpegURL',
          src: ''
        }],
        poster: data.banner, //你的封面地址
        width: document.documentElement.clientWidth,
        notSupportedMessage: '直播已结束' //允许覆盖Video.js无法播放媒体源时显示的默认信息。
      }
      if (name == 'play') {
        setTimeout(() => {
          this.$refs.videoPlayer.player.play()
        }, 100)
        this.showPoster = false;
      }
      let arr1 = data.start_at.split(/[- : /]/);
      console.log(arr1);
      this.liveStartTime = new Date(arr1[0], arr1[1] - 1, arr1[2], arr1[3], arr1[4], arr1[5]).getTime();
      let arr2 = data.end_at.split(/[- : /]/);
      this.liveEndTime = new Date(arr2[0], arr2[1] - 1, arr2[2], arr2[3], arr2[4], arr2[5]).getTime();
      this.currentTime = new Date().getTime();
      console.log(this.currentTime, this.liveStartTime)
      if (this.$store.state.videoUrl) {

        console.log('直播中')
        //录播
        this.playerOptions.sources[0].type = 'video/mp4';
        this.playerOptions.sources[0].src = this.$store.state.videoUrl;
      } else {
        //直播
        this.playerOptions.sources[0].type = 'application/x-mpegURL';
        if (this.currentTime > this.liveEndTime) {
          this.playerOptions.notSupportedMessage = '直播已結束';
          this.playerOptions.sources[0].src = null;
          this.liveStatus = 2;
        } else if (this.currentTime < this.liveStartTime) {
          this.playerOptions.sources[0].src = null;
          this.playerOptions.notSupportedMessage = '直播未开始';
          this.handleDate();
          this.liveStatus = 0;
          this.timeKeeper();
        } else {
          this.liveStatus = 1;
          this.playerOptions.sources[0].src = data.play_url_m3u8;
          this.playerOptions.notSupportedMessage = '无法播放';

        }
      }
      // if(this.liveDetails.banner_type == 2){
      //   setTimeout(()=>{
      //     this.coverToImg()
      //   },500)
      // }
    },

    //处理日程格式
    handleSchedule() {
      let recordedList = this.$store.state.recording[Object.keys(this.$store.state.recording)[0]];
      this.recordedList = recordedList
      console.log(recordedList)
      recordedList.forEach((item, index) => {
        item.details.forEach((val, ind) => {
          this.newRecordedList.push(item.details[ind].recordid)
        })
      })
    },
    //处理日期格式
    handleDate() {
      let currentTime = new Date().getTime();
      this.dValue = this.liveStartTime - currentTime;
      let dValue = this.dValue;
      this.countdown.days = parseInt(dValue / (1000 * 60 * 60 * 24));
      this.countdown.hours = parseInt((dValue % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      this.countdown.hours = this.countdown.hours < 10 ? '0' + this.countdown.hours : this.countdown.hours;
      this.countdown.mins = parseInt((dValue % (1000 * 60 * 60 * 24)) % (1000 * 60 * 60) / (1000 * 60));
      this.countdown.mins = this.countdown.mins < 10 ? '0' + this.countdown.mins : this.countdown.mins;
      this.countdown.seconds = parseInt((dValue % (1000 * 60 * 60 * 24)) % (1000 * 60 * 60) % (1000 * 60) / 1000);
      this.countdown.seconds = this.countdown.seconds < 10 ? '0' + this.countdown.seconds : this.countdown.seconds;

    },
    //到计时
    timeKeeper() {
      if (this.dValue < 1000) {
        this.liveStatus = 1;
        window.location.reload();
        this.clearCodeTimer();

      } else {
        codeTimer = setTimeout(() => {
          this.handleDate();
          this.timeKeeper()
        }, 1000)
      }
    },
    //清除定时器
    clearCodeTimer() {
      clearTimeout(codeTimer);
    },
    onVideoPlay() {
      if (this.liveDetails.banner_type == 2) {
        this.showPoster = false
      }
    },
    //解决自动全屏
    onPlayerPlay() {

      var ua = navigator.userAgent.toLocaleLowerCase();
      //x5内核
      if (ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null) {

        $('body').find('video').attr('x-webkit-airplay', true).attr('x5-playsinline', true).attr('webkit-playsinline', true).attr('playsinline', true).attr('x5-video-player-type', 'h5-page')
      } else {
        //ios端
        $('body').find('video').attr('webkit-playsinline', "true").attr('playsinline', "true").attr('x5-video-player-type', 'h5-page');

      }
    },
    //视频播放结束   自动播放下一个
    onPlayerEnd() {
      let newRecordedList = this.newRecordedList;
      let videoUrl = this.$store.state.videoUrl;
      newRecordedList.forEach((item, suffix) => {
        if (item == videoUrl && item != '') {
          this.playerOptions.sources[0].type = 'video/mp4';
          if (suffix == newRecordedList.length - 1) {
            this.playerOptions.sources[0].src = newRecordedList[0];
            this.$store.dispatch('receiveVideoUrl', newRecordedList[0]);
          } else {
            this.playerOptions.sources[0].src = newRecordedList[suffix + 1];
            this.$store.dispatch('receiveVideoUrl', newRecordedList[suffix + 1]);
          }
        }
      })
    }
  },
  computed: {
    playsinline() {
      var ua = navigator.userAgent.toLocaleLowerCase();
      //x5内核
      if (ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null) {
        return false
      } else {
        //ios端
        return true
      }
    }
  }
}
</script>
<style lang="scss">
.player-container {
  position: relative;

  .countdown,
  .liveEnd {
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 75%;
    height: 75px;
    padding: 0 8px;
    box-sizing: border-box;
    background-color: #232323;
    color: #fff;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }

  .countdown span {
    font-size: 20px;
    margin: 0px 3px;
    color: #901d22;
  }
}

.bg_cover {
  border-radius: 5px 5px 0 0;
  width: 100%;
  position: absolute;
  overflow: hidden;
  z-index: 99;
  // height: 130px;

  img {
    min-height: 110px;
    background-color: #fff;
    width: 100%;

  }

  ul {
    position: absolute;
    top: 0;
    bottom: 10px;
    padding: 22px;
    overflow: hidden;
    width: 100%;
    display: flex;
    flex-direction: column;

    li,
    p {
      font-size: 16px;
      margin: 10px 0;
      color: #fff;
      display: flex;
      align-items: baseline;

    }

    li span {
      display: inline-block;
      width: 5px;
      height: 5px;
      background: #000;
      border-radius: 50%;
      margin-right: 5px;
      flex-shrink: 0;

    }
  }
}

.player-icon {
  width: 80px;
  height: 60px;
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.5);
  border: 2px solid #fff;
  line-height: 74px;
  text-align: center;
  color: #fff;
  position: absolute;
  left: 0;
  right: 0;
  top: 30%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
}

@media screen and (min-width:800px) {
  .bg_cover {
    ul {
      padding: 8%;

      li,
      p {
        font-size: 20px;
      }

    }

    .player-icon {
      width: 120px;
      height: 80px;
      font-size: 46px;

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Meeting/Player.vue